import React from "react";
import styled from "styled-components";

import { titleOf } from "./kinds";
import { formatDay } from "./dates";

/** When the issue started, as the line ends: the crawl that found it, after the last crawl that saw the page healthy when no crawl found it, or since first crawled when the chain holds no healthy state. */
const SINCE = {
    changed: (day) => day && `since ${formatDay(day)}`,
    afterLastCrawl: (day) => day && `after ${formatDay(day)}`,
    neverHealthy: () => "since first crawled",
};

const sinceOf = ({ sinceKind, since }) => SINCE[sinceKind]?.(since);

/** One line per issue: what broke, or its kind when the kind says it all, and since when. */
export default function IssueList({ issues }) {
    return (
        <Grid>
            {issues.map((issue) => (
                <React.Fragment key={issue.kind + (issue.field || "")}>
                    <Name>
                        {issue.crawlError && <Muted>Crawl error · </Muted>}
                        {issue.detail || titleOf(issue.kind)}
                    </Name>
                    <Since>{sinceOf(issue)}</Since>
                </React.Fragment>
            ))}
        </Grid>
    );
}

/** The name column is as wide as the longest name, "Meta description lost", so the dates line up from row to row. */
const Grid = styled.div`
    display: grid;
    grid-template-columns: 128px minmax(0, 1fr);
    align-items: baseline;
    column-gap: 8px;
    row-gap: 2px;
    min-width: 0;
`;

const Name = styled.span`
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.76rem;
    font-weight: 500;
    color: #1e293b;
`;

const Muted = styled.span`
    font-size: 0.7rem;
    font-weight: 400;
    color: #a9b4c2;
`;

const Since = styled(Muted)`
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
